/** @jsx jsx */

import { ChangeEvent } from 'react';

import { Field, TextInput } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import ErrorMessage from './ErrorMessage';

const Styles = {
  root: css`
    width: 100%;
  `,
  textInput: css`
    margin-top: 7px;
  `,
};

type Props = {
  'aria-describedby': string;
  'aria-label': string;
  'aria-required': boolean;
  error?: boolean;
  errorMessage?: string;
  id: string;
  name: string;
  onChange: (args: string) => void;
  title: string;
  value: string;
};

function InputWithLabel({
  'aria-describedby': ariaDescribedBy,
  'aria-label': ariaLabel,
  'aria-required': ariaRequired,
  error,
  errorMessage,
  id,
  name,
  onChange,
  title,
  value,
}: Props) {
  return (
    <div css={Styles.root}>
      <Field
        label={title}
        renderInput={inputProps => (
          <TextInput
            {...inputProps}
            aria-describedby={ariaDescribedBy}
            aria-label={ariaLabel}
            aria-required={ariaRequired}
            id={id}
            name={name}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onChange(e.target.value)
            }
            value={value}
          />
        )}
      />
      {error && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </div>
  );
}

export default InputWithLabel;
